const lang = {
  contact: '聯絡方式',
  experience: '經歷',
  education: '學歷',
  skills: '技能專長',
  about: '自我介紹'
};
export default lang;



// WEBPACK FOOTER //
// ./src/lang/zh-tw.js